import { supabase } from "../supabaseClient";

export const DEFAULT_SOUNDCLOUD_URL = "https://soundcloud.com/mixordiamusic";

const CONFIG_KEY = "soundcloud_url";

let _cachedUrl = null;

export async function getSoundcloudUrl() {
  if (_cachedUrl) return _cachedUrl;
  if (!supabase) return DEFAULT_SOUNDCLOUD_URL;

  try {
    const { data, error } = await supabase
      .from("site_config")
      .select("value")
      .eq("key", CONFIG_KEY)
      .maybeSingle();

    if (error || !data?.value) return DEFAULT_SOUNDCLOUD_URL;

    _cachedUrl = data.value;
    return _cachedUrl;
  } catch (err) {
    console.error("[soundcloudService] failed to load SoundCloud URL:", err);
    return DEFAULT_SOUNDCLOUD_URL;
  }
}
